module.exports = {
    'es.transfer': {
        type: 'Tipo de reserva',
        meeting: 'Lugar de recogida',
        destination: 'Lugar de destino',
        passengers: 'Cantidad de pasajeros',

        round_arrive: 'Ida y vuelta - llegando a Valencia',
        one_arrive: 'Solo ida - llegando a Valencia',
        round_leave: 'Ida y vuelta - Saliendo de Valencia',
        one_leave: 'Solo ida - Saliendo de Valencia',

        airport: 'Aeropuerto de Valencia (Manises)',
        north_station: 'Estación del norte (Centro Valencia)',
        cabanal_station: 'Estación del cabañal (Centro Valencia)',
        joaquin_station: 'Estación Joaquin Sorolla (AVE)',
        port_balearia: 'Puerto de Valencia terminal de Balearia',
        port_trasmediterranea: 'Puerto de Valencia terminal Acciona Trasmediterranea',
        bus_station: 'Estación de Autobuses',

        calculate: 'Calcular precio',
        alert: 'Precio final, tasas e impuestos incluidos.',
        person: 'persona',

        default: 'Debe seleccionar uno...',
        send: 'Aceptar'
    },
    'en.transfer': {
        type: 'Type of reservation',
        meeting: 'Pick up place',
        destination: 'Destination place',
        passengers: 'Number of passengers',

        round_arrive: 'Round trip - Arriving Valencia',
        one_arrive: 'One way - Arriving in Valencia.',
        round_leave: 'Round trip - Leaving Valencia',
        one_leave: 'One way - Leaving Valencia.',

        airport: 'Airport of Valencia (Manises)',
        north_station: 'North Station (Center Valencia)',
        cabanal_station: 'Cabañal station (centro Valencia)',
        joaquin_station: 'Joaquin Sorolla station (AVE)',
        port_balearia: 'Port of Valencia Balearia terminal',
        port_trasmediterranea: 'Port of Valencia terminal Acciona Trasmediterranea',
        bus_station: 'Bus station',

        calculate: 'Calculate price',
        alert: 'Final price and taxes included',
        person: 'person',

        default: 'Debe seleccionar uno...',
        send: 'Accept'
    },
    'fr.transfer': {
        type: 'Type de réservation',
        meeting: 'Lugar de recogida',
        destination: 'Destination',
        passengers: 'Nombre de passagers',

        round_arrive: 'Départ-retour - atteindre Valence.',
        one_arrive: 'Départ - atteindre Valence.',
        round_leave: 'Départ-retour - En quittant Valence.',
        one_leave: 'Départ - En quittant Valence.',

        airport: 'L\'aéroport de Valence (Manises)',
        north_station: 'Gare du Nord (Centre de Valence)',
        cabanal_station: 'Station Cabañal (Centre de Valence)',
        joaquin_station: 'Station Joaquin Sorolla (AVE)',
        port_balearia: 'Terminal portuaire Valence Balearia',
        port_trasmediterranea: 'Valence Port Terminal Acciona Trasmediterranea',
        bus_station: 'Station de bus',

        calculate: 'Calculer prix',
        alert: 'Prix ​​final et taxes incluses.',
        person: 'personne',

        default: 'Debe seleccionar uno...',
        send: 'Accepter'
    }
};



// WEBPACK FOOTER //
// ./src/settings/Translations.js